import Pbf from 'pbf';
import PBFLayer from './PBFLayer';

const _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function _removePaddingChars(input) {
    const lkey = _keyStr.indexOf(input.charAt(input.length - 1));
    if (lkey === 64) {
        return input.substring(0, input.length - 1);
    }
    return input;
}

function _decode(aInput, arrayBuffer) {
    // get last chars to see if are valid
    let input = _removePaddingChars(aInput);
    input = _removePaddingChars(input);
    const bytes = parseInt((input.length / 4) * 3, 10);

    let uarray;
    let chr1;
    let chr2;
    let chr3;
    let enc1;
    let enc2;
    let enc3;
    let enc4;
    let i = 0;
    let j = 0;
    if (arrayBuffer) {
        uarray = new Uint8Array(arrayBuffer);
    } else {
        uarray = new Uint8Array(bytes);
    }

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, ""); // eslint-disable-line

    for (i = 0; i < bytes; i += 3) {
        // get the 3 octects in 4 ascii chars
        enc1 = _keyStr.indexOf(input.charAt(j++));
        enc2 = _keyStr.indexOf(input.charAt(j++));
        enc3 = _keyStr.indexOf(input.charAt(j++));
        enc4 = _keyStr.indexOf(input.charAt(j++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        uarray[i] = chr1;
        if (enc3 !== 64) uarray[i + 1] = chr2;
        if (enc4 !== 64) uarray[i + 2] = chr3;
    }

    return uarray;
}

/* will return a  Uint8Array type */
function _decodeArrayBuffer(input) {
    const bytes = (input.length / 4) * 3;
    const ab = new ArrayBuffer(bytes);

    return _decode(input, ab);
}

function _pbf2Json(tile, ratio, dimension) {
    const data = {};
    for (const layerName in tile) {
        if (tile.hasOwnProperty(layerName)) {
            const features = [];
            const layer = tile[layerName];
            for (let i = 0; i < layer.length; i++) {
                const feat = layer.feature(i);
                const feature = {
                    geometry: null,
                    properties: {}
                };
                for (const [key, value] of Object.entries(feat.properties)) {
                    try {
                        feature.properties[key] = JSON.parse(value);
                    } catch (e) {
                        feature.properties[key] = value;
                    }
                }
                feature.geometry = feat.loadGeometry(ratio, dimension);
                features.push(feature);
            }
            data[layerName] = features;
        }
    }

    return data;
}

function readTile(tag, layers, pbf) {
    if (tag === 3) {
        const layer = new PBFLayer(pbf, pbf.readVarint() + pbf.pos);
        if (layer.length) layers[layer.name] = layer;
    }
}

/**
 * 解析二进制的pbf数据
 * @param {*} arrayBuffer 二进制数据
 * @param {*} ratio       倍率，为了传输方便，会将数据放大
 * @param {*} dimension   维度：2.二维；3：三维
 */
function arrayBufferToJson(arrayBuffer, ratio = 16, dimension = 2) {
    const pbf = new Pbf(arrayBuffer);
    const tile = pbf.readFields(readTile, {});

    return _pbf2Json(tile, ratio, dimension);
}

/**
 * 解析base64字符串的pbf数据
 * @param {*} base64Str 字符串
 * @param {*} dimension 维度：2.二维；3：三维
 */
function base64ToJson(base64Str, ratio = 1000, dimension = 2) {
    // const ab = _decodeArrayBuffer(base64Str); 由于变量值较大，这里取消了临时变量的创建

    return arrayBufferToJson(_decodeArrayBuffer(base64Str), ratio, dimension);
}

export default {
    arrayBufferToJson,
    base64ToJson
};
